import { cx } from '@/lib/cx'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'danger-ghost'

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-accent-fg hover:bg-accent-hover',
  secondary: 'border border-border bg-surface text-fg hover:bg-accent-soft',
  ghost: 'text-accent-ink hover:bg-accent-soft',
  danger: 'bg-danger text-white hover:brightness-90',
  'danger-ghost': 'text-danger hover:bg-danger-soft',
}

const sizes = {
  md: 'min-h-tap px-4 text-base',
  sm: 'min-h-9 px-3 text-sm',
}

export type ButtonSize = keyof typeof sizes

/** The button's look for a `Link` or anything else that is not a `<button>`. */
export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md'): string {
  return cx(
    'inline-flex items-center justify-center gap-2 rounded-lg font-medium select-none',
    'focus-visible:ring-accent focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
    variants[variant],
    sizes[size],
  )
}
